import React, { useState, useRef, useEffect, useContext } from "react";
import "./CustomDropdown.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { GlobalStateContext } from "../../context/GlobalStateContext";

function CustomDropdown({ options, placeholder, filterType }) {
  const { updateFilters, filters } = useContext(GlobalStateContext);
  const [isOpen, setIsOpen] = useState(false); // Dropdown visibility
  const [selectedItems, setSelectedItems] = useState([]); // Selected options
  const [searchTerm, setSearchTerm] = useState(""); // Search filter
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null); // Reference for outside click
  // Filter options based on search term
  const handleFilter = () => {
    return options.filter((option) =>
      option?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };
  const handleShowBtnClick = () => {
    updateFilters({ [filterType]: selectedItems });
    setIsOpen(false);
  };
  // Toggle dropdown visibility
  const toggleDropDown = () => {
    setIsOpen(!isOpen);
  };

  // Handle option selection
  const handleOptionClick = (option) => {
    let updatedSelection;
    if (selectedItems.includes(option)) {
      updatedSelection = selectedItems.filter((item) => item !== option);
    } else {
      updatedSelection = [...selectedItems, option];
    }
    setSelectedItems(updatedSelection);
    // updateFilters({
    //   [filterType]: updatedSelection,
    // });
  };

  // Handle removing selected items
  const cancelSelection = () => {
    setSelectedItems([]);
    updateFilters({
      [filterType]: [],
    });
    setTimeout(() => {
      setIsOpen(false);
    }, 500);
  };
  // useeffect to handle when component mounts side effects
  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);
  //useeffect to handle the change in search term
  useEffect(() => {
    setFilteredOptions(handleFilter());
  }, [searchTerm]);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  return (
    <>
      <div
        className={
          (filterType === "companyNames" && filters.companyNames.length > 0) ||
          (filterType === "companyCountries" &&
            filters.companyCountries.length > 0) ||
          (filterType === "sectors" && filters.sectors.length > 0)
            ? "custom-dropdown customDropdownActive"
            : "custom-dropdown"
        }
        ref={dropdownRef}
      >
        <div onClick={toggleDropDown} className="dropdown-selected ">
          {placeholder}
        </div>
        {(filterType === "companyNames" && filters.companyNames.length > 0) ||
        (filterType === "companyCountries" &&
          filters.companyCountries.length > 0) ||
        (filterType === "sectors" && filters.sectors.length > 0) ? (
          <div className="selectedFiltersCount">
            <span>
              {filterType === "companyNames" && filters.companyNames.length > 0
                ? filters.companyNames.length
                : filterType === "companyCountries" &&
                  filters.companyCountries.length > 0
                ? filters.companyCountries.length
                : filterType === "sectors" && filters.sectors.length > 0
                ? filters.sectors.length
                : null}
            </span>
          </div>
        ) : null}
        <ExpandMoreIcon className="ExpandMoreIcon" onClick={toggleDropDown} />
        {isOpen && (
          <div className={`dropdown-options  ${filterType}Dropdown`}>
            <div className="dropDownMenuBeforeHr">
              <div className="dropdown-search">
                <SearchIcon className="search-icon" />
                <input
                  className="searchInput"
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="dropDownOptionsMenu scroller">
                {filteredOptions.map((option, index) => (
                  <React.Fragment key={index}>
                    <div className="dropdown-item">
                      <label
                        className={
                          selectedItems.includes(option) && "labelChecked"
                        }
                      >
                        <input
                          className="dropDownItemCheckBox"
                          type="checkbox"
                          checked={selectedItems.includes(option)}
                          onChange={() => {
                            handleOptionClick(option);
                          }}
                        />
                        <p className="dropDownItemTxt"> {option}</p>
                      </label>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
            <CloseIcon className="DropDownCLoseIcon" onClick={toggleDropDown} />
            <hr className="dropDownHr" />
            <div className="btnDropDownContainer">
              <button onClick={cancelSelection}>Deselect</button>
              <button onClick={handleShowBtnClick} className="ShowBtn">
                Show {selectedItems?.length} {placeholder}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CustomDropdown;
